import React from 'react'

// process names
export const HOME = "home";
export const CANNIBALISM = "Cannibalism";
export const MEIOSIS = "Meiosis";
export const RECOMBINATORIAL_REPAIR = "Recombinatorial Repair";
export const BINARY_FISSION = "Binary Fission";
export const CONJUGATION = "Conjugation";
export const MITOSIS = "Mitosis";
export const SPORE_SHOOTING = "Spore Shooting";
export const SPECIALISED_TRANSDUCTION = "Specialised Transduction";
export const BACTERIAL_TRANSFORMATION = "Bacterial Transformation";
export const CANNIBALISM_2 = "Cannibalism II";
export const MEIOSIS_2 = "Meiosis II";
export const RECOMBINATORIAL_REPAIR_2 = "Recombinatorial Repair II";
export const BINARY_FISSION_2 = "Binary Fission II";
export const CONJUGATION_2 = "Conjugation II";
export const MITOSIS_2 = "Mitosis II";
export const SPORE_SHOOTING_2 = "Spore Shooting II";
export const SPECIALISED_TRANSDUCTION_2 = "Specialised Transduction II";
export const BACTERIAL_TRANSFORMATION_2 = "Bacterial Transformation II";

// strings matching the file names in /assets
export const AssetIDs = [
    "ca1", "mo1", "rr1", "bf1", "cj1", "mt1", "ss1", "st1", "bt1",
    "ca2", "mo2", "rr2", "bf2", "cj2", "mt2", "ss2", "st2", "bt2"
];

// get a specific Asset ID by section
export function GetAssetID(section) {
    switch (section) {
        case HOME:
            return "reset";
        case CANNIBALISM:
            return "ca1";
        case CANNIBALISM_2:
            return "ca2";
        case MEIOSIS:
            return "mo1"
        case MEIOSIS_2:
            return "mo2";
        case RECOMBINATORIAL_REPAIR:
            return "rr1"
        case RECOMBINATORIAL_REPAIR_2:
            return "rr2";
        case BINARY_FISSION:
            return "bf1"
        case BINARY_FISSION_2:
            return "bf2";
        case CONJUGATION:
            return "cj1"
        case CONJUGATION_2:
            return "cj2";
        case MITOSIS:
            return "mt1"
        case MITOSIS_2:
            return "mt2";
        case SPORE_SHOOTING:
            return "ss1"
        case SPORE_SHOOTING_2:
            return "ss2";
        case SPECIALISED_TRANSDUCTION:
            return "st1"
        case SPECIALISED_TRANSDUCTION_2:
            return "st2";
        case BACTERIAL_TRANSFORMATION:
            return "bt1"
        case BACTERIAL_TRANSFORMATION_2:
            return "bt2";
        default:
            return "❗ Error - unknown section name: " + section;
    }
}

// get the ID of a process type (eg. Cannibalism = "ca") by section
export function GetProcessID(section) {
    switch (section) {
        case HOME:
            return "reset";
        case CANNIBALISM:
        case CANNIBALISM_2:
            return "ca";
        case MEIOSIS:
        case MEIOSIS_2:
            return "mo";
        case RECOMBINATORIAL_REPAIR:
        case RECOMBINATORIAL_REPAIR_2:
            return "rr";
        case BINARY_FISSION:
        case BINARY_FISSION_2:
            return "bf";
        case CONJUGATION:
        case CONJUGATION_2:
            return "cj";
        case MITOSIS:
        case MITOSIS_2:
            return "mt";
        case SPORE_SHOOTING:
        case SPORE_SHOOTING_2:
            return "ss";
        case SPECIALISED_TRANSDUCTION:
        case SPECIALISED_TRANSDUCTION_2:
            return "st";
        case BACTERIAL_TRANSFORMATION:
        case BACTERIAL_TRANSFORMATION_2:
            return "bt";
        default:
            return "❗ Error - unknown section name: " + section;
    }
}

// get the title for each asset ID
export function GetTitle(assetID) {
    switch (assetID) {
        case "reset":
            return HOME;
        case "ca1":
            return CANNIBALISM;
        case "ca2":
            return CANNIBALISM_2;
        case "mo1":
            return MEIOSIS;
        case "mo2":
            return MEIOSIS_2;
        case "rr1":
            return RECOMBINATORIAL_REPAIR;
        case "rr2":
            return RECOMBINATORIAL_REPAIR_2;
        case "bf1":
            return BINARY_FISSION;
        case "bf2":
            return BINARY_FISSION_2;
        case "cj1":
            return CONJUGATION;
        case "cj2":
            return CONJUGATION_2;
        case "mt1":
            return MITOSIS;
        case "mt2":
            return MITOSIS_2;
        case "ss1":
            return SPORE_SHOOTING;
        case "ss2":
            return SPORE_SHOOTING_2;
        case "st1":
            return SPECIALISED_TRANSDUCTION;
        case "st2":
            return SPECIALISED_TRANSDUCTION_2;
        case "bt1":
            return BACTERIAL_TRANSFORMATION;
        case "bt2":
            return BACTERIAL_TRANSFORMATION_2;
        default:
            return "❗ Error - unknown asset ID: " + assetID;
    }
}

// get the text description for each section
export function GetDescription(section) {
    switch (section) {
        case HOME:
            return (
                <p>
                    These recordings are results of recursive responses to microbial sex processes by Mia Windsor (electronics) and Ande Clock (cello). They have been mapped into looping paths by Mia, and are accompanied by interactive visuals by Ande which mirror the corresponding sex processes.
                    <br/>
                    <br/>
                    The sounds created follow relational loops which you can follow paths through. The electronic parts take their source material entirely from other cello parts, such that every piece of audio you are hearing takes material from the previous.
                    <br/>
                    <br/>
                    Click on a process and have a listen. The buttons for the next path will appear when the audio has played.
                    <br/>
                    <br/>
                    While listening, drag and click your mouse over the visuals and have some microbe sex fun!
                    <br/>
                    <br/>
                    As you listen, no clock will tick - you are invited to experience a taste of microbial deep time, and stay and play until new paths are revealed.
                </p>
            )
        case CANNIBALISM:
        case CANNIBALISM_2:
            return <p>.......cannibalism</p>;
        case MEIOSIS:
        case MEIOSIS_2:
            return (
                <p>
                    A cell duplicates all of its contents, including its chromosomes, and
                    splits to form two identical daughter cells
                </p>
            );
        case RECOMBINATORIAL_REPAIR:
        case RECOMBINATORIAL_REPAIR_2:
            return (
                <p>
                    A mechanism for generating a functional DNA molecule from two damaged
                    molecules.
                </p>
            );
        case BINARY_FISSION:
        case BINARY_FISSION_2:
            return <p>A cell splits into two identical daughter cells.</p>;
        case CONJUGATION:
        case CONJUGATION_2:
            return (
                <p>
                    Two bacteria — a donor and a recipient — sidle up to each other and
                    get close. The donor creates a tube, called a pilus, that attaches to
                    the recipient and pulls the two cells together. A plasmid from the
                    donor passes to the recipient, providing the recipient with new
                    genetic information.
                </p>
            );
        case MITOSIS:
        case MITOSIS_2:
            return (
                <p>
                    A cell splits and halves its genetic information (egg and sperm). This
                    allows for gene shuffling.
                </p>
            );
        case SPORE_SHOOTING:
        case SPORE_SHOOTING_2:
            return (
                <p>
                    Seeds are shot out sometimes at great speed, carried by wind or rain.
                    If they land somewhere fertile they grow into new fungi and thus, the
                    other 'partner' is an element - wind or rain.
                </p>
            );
        case SPECIALISED_TRANSDUCTION:
        case SPECIALISED_TRANSDUCTION_2:
            return (
                <p>
                    Transmission of a specific (usually small) amount of genetic
                    information from one bacteria to another via a virus.
                </p>
            );
        case BACTERIAL_TRANSFORMATION:
        case BACTERIAL_TRANSFORMATION_2:
            return (
                <p>
                    The uptake of DNA molecules through the cell wall form its external
                    surroundings.
                </p>
            );
        default:
            return <p>❗ Error - unknown section name: {section}</p>;
    }
}

// get the next asset IDs by each asset ID
export function GetNext(assetID) {
    switch (assetID) {
        case "reset":
            return AssetIDs; // all?
        case "ca1":
            return ["mo2", "rr2"];
        case "ca2":
            return ["cj1"];
        case "mo1":
            return ["bf2", "cj2"];
        case "mo2":
            return ["rr1", "bt1"];
        case "rr1":
            return ["mt2"];
        case "rr2":
            return ["ca1", "bt1"];
        case "bf1":
            return ["bt2", "st2"];
        case "bf2":
            return ["bt1", "cj1", "ss1"];
        case "cj1":
            return ["cj2"];
        case "cj2":
            return ["mt1", "st1"];
        case "mt1":
            return ["bt2", "st2"];
        case "mt2":
            return ["rr1", "st1"];
        case "ss1":
            return ["mt2", "rr2", "bt2"];
        case "ss2":
            return ["bt1", "mo1"];
        case "st1":
            return ["st2", "ss2"];
        case "st2":
            return ["bf1"];
        case "bt1":
            return ["ca2"];
        case "bt2":
            return ["bf1"];
        default:
            return "❗ Error - unknown asset ID: " + assetID;
    }
}
